import { InjectionToken } from '@angular/core';
import type { Observable } from 'rxjs';

/**
 * Fila del panel de notificaciones alineada con `/api/notifications` (mismo contrato que el portal Next).
 */
export interface VaultBackendNotificationRow {
  id: string;
  titulo: string;
  mensaje: string;
  /** ISO 8601 */
  fecha: string;
  leida: boolean;
  tipo: 'success' | 'info' | 'warning' | 'error';
}

/**
 * Puerto opcional: si la app shell lo provee (p. ej. con `NotificationsService` de `@nebula/vault`),
 * el panel del header sincroniza listado y marcar leídas contra el backend.
 */
export interface VaultBackendNotificationsPort {
  list(unreadOnly: boolean): Observable<VaultBackendNotificationRow[]>;
  markAsRead(id: string): Observable<unknown>;
  markAllAsRead(): Observable<unknown>;
}

export const VAULT_BACKEND_NOTIFICATIONS = new InjectionToken<VaultBackendNotificationsPort | null>(
  'VAULT_BACKEND_NOTIFICATIONS',
);
